







import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateTimeDuration } from "../../../domain/system";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "./mixins";
import OptionDropDownSelector from "./OptionDropDownSelector.vue";
import DateTimeDurationPicker from "./DateTimeDurationPicker.vue";

@Component({
  components: {
    OptionDropDownSelector,
    DateTimeDurationPicker,
  }
})
export default class PresettableDateTimeDurationPicker extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: () => [] as StandardOption<DateTimeDuration>[] })
  presets: StandardOption<DateTimeDuration>[];

  get isPresettable(): boolean {
    return !!this.presets
      && (0 < this.presets.length);
  }

  areEqual(source: DateTimeDuration, destination: DateTimeDuration): boolean {
    return DateTimeDuration.areEqual(source, destination);
  }
}
